import {
    Box,
    Card,
    CardContent,
    Tabs,
    Tab,
} from '@mui/material';
import { useState } from 'react';

import InsightsIcon from '@mui/icons-material/Insights';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';

import StrategyTab from './tabs/Strategy';
import OddsTab from './tabs/Odds';
import ClusteringTab from './tabs/Clustering';

export const InsightsOverview = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Box>
            <Card>
                <CardContent sx={{ p: 0, "&:last-child": { paddingBottom: 0 } }}>
                    <Tabs
                        value={tabIndex}
                        onChange={(_, newValue) => setTabIndex(newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                        <Tab
                            icon={<InsightsIcon />}
                            label="Strategy"
                            iconPosition="start"
                            sx={{
                                minHeight: 48,   // reduce vertical height
                                paddingY: 1,
                                textTransform: 'none',
                            }}
                        />
                        <Tab
                            icon={<HubOutlinedIcon />}
                            label="Clustering"
                            iconPosition="start"
                            sx={{
                                minHeight: 48,
                                paddingY: 1,
                                textTransform: 'none',
                            }}
                        />
                        <Tab
                            icon={<CasinoOutlinedIcon />}
                            label="Odds"
                            iconPosition="start"
                            sx={{
                                minHeight: 48,
                                paddingY: 1,
                                textTransform: 'none',
                            }}
                        />
                    </Tabs>

                    {tabIndex === 0 && <StrategyTab />}
                    {tabIndex === 1 && <ClusteringTab />}
                    {tabIndex === 2 && <OddsTab />}
                </CardContent>
            </Card>
        </Box>
    );
};